import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import MapFilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import universalFieldsFieldModel from "@app/util/fieldModel/universalFieldsFieldModel";

const convertFilterModelToMapFilterModelForEntity = (
  entityType: EntityTypesSupportedByMapsPage,
  filterModel: FilterModel
) => {
  const mapFilterModel: MapFilterModel = { [entityType]: {}, universal: {} };
  Object.keys(filterModel).forEach((fieldName) => {
    (universalFieldsFieldModel.getByName(fieldName)?.hasFeature(FieldFeature.FILTERABLE_ON_MAP)
      ? mapFilterModel.universal!
      : mapFilterModel[entityType]!)[fieldName] = filterModel[fieldName];
  });
  return mapFilterModel;
};

export default convertFilterModelToMapFilterModelForEntity;
